import React from 'react'
import { ConfiguredInterface } from '../list/ListTypes'

const InterfaceItemNoKey = 'interface-item-no'
const MechItemNoKey = 'mech-item-no'
const OriginKey = 'origin-index-no'

export interface ConfiguredSwapInterface {
  originIndex: number
}

export function putData(e: React.DragEvent, interfaceItemNo: string, mechItemNo: string | null, originIndex: number | null) {
  e.dataTransfer.setData(InterfaceItemNoKey, interfaceItemNo)
  if (mechItemNo !== null) {
    e.dataTransfer.setData(MechItemNoKey, mechItemNo)
  }

  if (originIndex !== null) {
    e.dataTransfer.setData(OriginKey, originIndex.toString())
  }
}

export function hasData(e: React.DragEvent): boolean {
  return e.dataTransfer.types.includes(InterfaceItemNoKey)
}

export function getSwappedData(e: React.DragEvent): ConfiguredSwapInterface | null {
  try {
    const originIndex = parseInt(e.dataTransfer.getData(OriginKey))
    if (!isNaN(originIndex)) {
      return {
        originIndex
      }
    }
  } catch (e) { }

  return null
}

export function getData(e: React.DragEvent): ConfiguredInterface | null {
  const interfaceItemNo = e.dataTransfer.getData(InterfaceItemNoKey)
  const mechItemNo = e.dataTransfer.getData(MechItemNoKey) || null
  try {
    if (interfaceItemNo.length > 0) {
      return {
        interfaceItemNo,
        mechItemNo
      }
    }
  } catch (e) { }

  return null
}
